<template>
<div style="height: 100%">
    <div class="loadingContainer" v-if="loadingContainer.remind">
        <div class="loadingContainer_icon">
            <i class="el-icon-loading loadingContainer_icon_loading" v-if="loadingContainer.remind === '表单页面加载中。。。'" />
            <i class="el-icon-error loadingContainer_icon_error" v-else />
        </div>
        <div class="loadingContainer_remind">
            <p>{{loadingContainer.remind}}</p>
        </div>
    </div>
    <view-form v-else ref="viewForm"  :viewFormData="viewFormData" >
    </view-form>
</div>
</template>

<script>
import viewForm from '@/workFlow/formComponent/viewForm/ViewForm.vue'
// import { ProcessingFormSetting, bindEvent } from '@/workFlow/utils/flow'
import { HandleForm } from '@/workFlow/utils/flowUtils'

export default {
  components: {
    viewForm
  },
  data() {
    return {
      // 加载容器控制器
      loadingContainer: {
        remind: '表单页面加载中。。。'
      },
      viewFormData: {
        // 流程状态详情
        ProcessState: 'unknownState',
        // 操作类型
        pageKey: 'DO',
        // 表单的数据
        modelData: {},
        // 表单的配置
        options: {},
        keyInfo: {},
        // 会签控制
        sign: {
          // 是否会签模式
          isSign: false,
          // 会签数据
          signData: {}
        }
      }

    }
  },

  mounted() {
    let row = this.$route.query
    let pageKey = this.$route.query.pageKey
    if (!(row && pageKey)) {
      row = this.$route.params.row
      if (row.taskFormKey && row.taskFormKey.length > 0) {
        row.formId = row.taskFormKey[0]
      }
      pageKey = this.$route.params.pageKey
      if (!(row && pageKey)) {
        this.$message.error('缺失参数,请联系管理员')
        this.$router.push({
          path: '/404'
        })
      }
    }
    this.pageKey = pageKey
    this.openForm(row)
  },

  methods: {
    openForm(row) {
      if (this.pageKey === 'VIEW') { // 查看流程相关
      // 1.第一步:根据行数据中的 processInstanceId 获取到表单ID
        this.getFormId(row.processInstanceId, row.formId, (formId, procDefId) => {
          // 2.第二步:根据第一步获取到的formId获取表单模型
          this.getFormModelDetailByFormId(formId, procDefId, (modelJson) => {
            // 3.第三步:根据行数据中的businessKey(dataId) 获取表单对应的内容
            this.getFormData(row.businessKey, formId, procDefId, '', (modeldata) => {
            // 4.第四步：到此为止,数据就已经获取完毕 modelJson modeldata row.processInstanceId

            /** 将表单模型处理为查看模式  */
            // ProcessingFormSetting(modelJson.column, null, true)

              this.viewFormData.modelData = modeldata
              this.viewFormData.options = modelJson
              this.viewFormData.pageKey = 'VIEW'
              this.viewFormData.ProcessState = modeldata.ProcessState// (!row.taskName || row.taskName === '已完成') ? 'completed' : 'ongoing'
              this.viewFormData.keyInfo = {
                processInstanceId: row.processInstanceId,
                formId,
                taskId: row.taskId,
                businessKey: row.businessKey
              }
              HandleForm.bind(this, modelJson.column, null, true)()
              if (modelJson.group) {
                modelJson.group.forEach(groupItem => {
                  HandleForm.bind(this, groupItem.column, null, true)()
                })
              }
              this.loadingContainer.remind = ''
              this.$nextTick(() => {
                this.$refs.viewForm.Initialize()
              })
            })
          })
        })
      } else if (this.pageKey === 'DO') { // 操作流程相关
      // 1.第一步:根据行传递过来的数据ID 表单ID 获取表单对应的数据
        this.getFormData(row.businessKey, row.formId, '', row.taskId, (modeldata) => {
        // 2.第二步:根据行中的数据ID、任务ID获取待办任务描述
          this.getToDoTaskDescription(row.businessKey, row.taskId, modeldata, row.formId, (ToDoTaskDescription) => {
            // 3. 第三步:到此为止,数据已经获取完毕 modeldata ToDoTaskDescription row.businessKey row.taskId row.formId
            if (ToDoTaskDescription && Array.isArray(ToDoTaskDescription.formKeyList) && ToDoTaskDescription.formKeyList.length > 0) {
            /** 判断是否会签模式 */
              if (ToDoTaskDescription.formKeyList.length > 1) {
              // 会签模式
                this.viewFormData.sign.isSign = true
                this.viewFormData.sign.signData = ToDoTaskDescription
              } else {
              // 非会签模式
                this.viewFormData.sign.isSign = false
              }

              this.viewFormData.modelData = Object.assign(modeldata, { taskId: row.taskId })

              // 主表的表单模型,无论会签、非会签  都只考虑主表受流程字段控制。
              let formModelJson = ToDoTaskDescription.formModelJsonList[0]
              // 流程引擎给出的字段控制
              let taskFormJson = ToDoTaskDescription.taskFormPropertyList
              // 处理表单
              // ProcessingFormSetting(formModelJson.column, taskFormJson)

              this.viewFormData.options = formModelJson
              this.viewFormData.editMode = ToDoTaskDescription.editMode
              this.viewFormData.processDefinitionId = ToDoTaskDescription.processDefinitionId
              this.viewFormData.taskDefinitionKey = ToDoTaskDescription.taskDefinitionKey
              this.viewFormData.pageKey = 'DO'
              this.viewFormData.ProcessState = 'ongoing'
              this.viewFormData.keyInfo = {
                processInstanceId: row.processInstanceId,
                formId: ToDoTaskDescription.formKeyList[0],
                taskId: row.taskId,
                businessKey: row.businessKey
              }
              this.viewFormData.taskFormPropertyList = ToDoTaskDescription.taskFormPropertyList
              // bindEvent.bind(this)()
              HandleForm.bind(this, formModelJson.column, taskFormJson)()
              if (formModelJson.group) {
                formModelJson.group.forEach(groupItem => {
                  HandleForm.bind(this, groupItem.column, taskFormJson)()
                })
              }
              this.loadingContainer.remind = ''
              this.$nextTick(() => {
                this.$refs.viewForm.Initialize()
              })
            } else {
              this.$message.error('流程异常: 获取到的表单ID(formKeyList)异常。')
            }
          })
        })
      }
    },
    forceUpdate() {
      try {
        this.$refs.viewForm.$refs.avueform.$forceUpdate()
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * 根据流程实例ID获取表单ID
     * @param {String} processInstanceId 流程实例ID
     * @param {Function} callback  回调函数,callback参数为formId
     */
    getFormId(processInstanceId, formId, callback) {
      if (formId) {
        callback(formId)
      } else {
        this.$http.get('/flow-ext/process-form-key-and-process-version', {
          params: {
            processInstanceId
          }
        }).then(response => {
          callback(response.data.formId, response.data.procDefId)
        }).catch(error => {
          this.loadingContainer.remind = error.msg || error.message
          this.$message.error(error.msg || error.message)
        })
      }
    },
    /**
         * 查询表单的数据
         * @param {String} (businessKey || dataId)  数据id
         * @param {String} formId   表单的id
         */
    getFormData(dataId, formId, procDefId, taskId, callback) {
      if (dataId) {
        this.$http.get('/form-instance/select', {
          params: {
            dataId,
            formId,
            procDefId,
            taskId
          }
        }).then(response => {
          callback(response.data)
        }).catch(error => {
          this.loadingContainer.remind = error.msg || error.message
          this.$message.error(error.msg || error.message)
        })
      } else {
        callback({})
      }
    },
    /**
         * 根据表单ID获取表单模型信息
         * @param {String} formId   表单的id
         */
    getFormModelDetailByFormId(formId, procDefId, callback) {
      this.$http.get('/form-model/detail', {
        params: {
          formId,
          procDefId
        }
      }).then(response => {
        callback(response.data.modelJson)
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error(error.msg || error.message)
      })
    },
    /**
         * 根据数据ID,任务ID获得待办任务的描述
         * @param {String} businessKey   数据ID
         * @param {String} taskId   任务ID
         */
    getToDoTaskDescription(businessKey, taskId, modeldata, formId, callback) {
      if (modeldata.processInstanceId && !taskId) {
        this.$message.error('流程数据，请提供待办环节id！')
        return
      } else if (!taskId) {
        this.$http.get('/form-instance/default-data-collection', {
          params: {
            formId
          }
        }).then(response => {
          let taskFormPropertyList = []
          response.data.column.forEach(item => {
            taskFormPropertyList.push({
              id: item.prop,
              readable: true,
              writable: true
            })
          })
          if (response.data.group) {
            response.data.group.forEach(groupItem => {
              groupItem.column.forEach(item => {
                taskFormPropertyList.push({
                  id: item.prop,
                  readable: true,
                  writable: true
                })
              })
            })
          }
          let description = { formKeyList: [formId], formModelJsonList: [response.data], taskFormPropertyList: taskFormPropertyList }
          callback(description)
        }).catch(error => {
          this.loadingContainer.remind = error.msg || error.message
          this.$message.error(error.msg || error.message)
        })
      } else {
        this.$http.get('/flow-ext/todo-task-description', {
          params: {
            businessKey,
            taskId
          }
        }).then(response => {
          callback(response.data)
        }).catch(error => {
          this.pageKey = 'VIEW'
          let row = {
            businessKey: modeldata.id,
            processInstanceId: modeldata.processInstanceId,
            taskId: '',
            taskName: '',
            formId: formId,
            pageKey: 'VIEW',
            msg: error.msg || error.message
          }
          this.openForm(row)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.loadingContainer{
  width:500px;
  margin:0 auto;
  padding: 5px 0;
  color:rgb(59,156,217);
  text-align:center;
  font-weight:600;
  &_icon{
    font-size:25px;
    &_error{ color:red;}
  }
  &_remind{
    p{
      margin: 0;
      width:100%;
    }
  }
}
</style>
